
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 400 400","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(16.666666666666668,0,0,16.666666666666668,0,0)"}},[_c('path',{attrs:{"d":"M11.25 7.5L14.25 4.5 11.25 1.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M20.969,12.75c.02.247.031.5.031.75a8.973,8.973,0,0,1-.284,2.25","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M18.894,7.715a8.968,8.968,0,0,1,1.229,1.906","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M18.872,19.312q-.24.284-.508.552a8.979,8.979,0,0,1-1.792,1.39","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M12.75,22.469c-.247.02-.5.031-.75.031a9,9,0,0,1,0-18h2.25","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    